import { IUser } from "@/shared/model/user.model";
import { Address } from "./address.model";

export interface IClient {
  id?: number;
  firstName?: string;
  lastName?: string;
  mail?: string;
  phoneNb?: string;
  gender?: string;
  creationDate?: Date;
  currency?: string;
  manager?: IUser;
  status360?: string;
  statusEsg?: string;
  yearOfBirth?: string;
  address?: Address;
  distance?: number;
  frequency?: string;
}

export class Client implements IClient {
  constructor(
    public id?: number,
    public firstName?: string,
    public lastName?: string,
    public mail?: string,
    public phoneNb?: string,
    public gender?: string,
    public creationDate?: Date,
    public currency?: string,
    public manager?: IUser,
    public status360?: string,
    public statusEsg?: string,
    public yearOfBirth?: string,
    public address?: Address,
    public frequency?: string,
    public distance: number = 60 // initialize value at 60
  ) {}
}

